<template>
  <Popover ref="edgeworkPopover" :showHeader="true" headerTitle="Edgework">
    <div class="order-item-edgework-popover-content">

      <EdgeworkSelection v-model="flagList" @update="$emit('update', flagList)" />

    </div>
  </Popover>
</template>

<style scoped>
.order-item-edgework-popover-content {
  padding: 10px;
  min-width: 250px;
  font-size: 12px;
}
</style>

<script>
import _ from 'lodash'
import Popover from '@/components/popover.vue'
import EdgeworkSelection from '@/modules/orders/components/edgeworkSelection'

export default {
  name: 'OrderItemEdgeworkPopover',
  model: {
    event: 'update'
  },
  components: {
    Popover,
    EdgeworkSelection
  },
  props: {
    value: Array
  },
  data() {
    return {
      flagList: _.clone(this.value || [])
    }
  },
  watch: {
    value: function(newValue) {
      this.flagList = _.clone(newValue || [])
    }
  },
  methods: {
    displayFromElement(element) {
      this.$refs.edgeworkPopover.displayFromElement(element)
    }
  }
}
</script>